var map = {
	"./china.svg": 266,
	"./circle_black.svg": 970,
	"./circle_blue.svg": 971,
	"./cn.svg": 972,
	"./ellipse_black.svg": 973,
	"./forgotpassword.svg": 323,
	"./france.svg": 267,
	"./highlighted_yellow.svg": 974,
	"./icons/_info.svg": 975,
	"./icons/add_prod.svg": 270,
	"./icons/add_prodOLD.svg": 976,
	"./icons/ask.svg": 977,
	"./icons/facebook.svg": 37,
	"./icons/hatchef.svg": 51,
	"./icons/icone/_info.svg": 978,
	"./icons/icone/hatchef.svg": 979,
	"./icons/icone/info.svg": 980,
	"./icons/icone/play.svg": 981,
	"./icons/icone/plus.svg": 982,
	"./icons/icone/specs.svg": 983,
	"./icons/icone/world.svg": 984,
	"./icons/index-icon-bookmark.svg": 985,
	"./icons/index-icon.svg": 412,
	"./icons/info.svg": 52,
	"./icons/markers-SVG/ask.svg": 986,
	"./icons/markers-SVG/info.svg": 987,
	"./icons/markers-SVG/list.svg": 988,
	"./icons/markers-SVG/recipe.svg": 989,
	"./icons/markers-SVG/web.svg": 990,
	"./icons/play.svg": 46,
	"./icons/play_ip.svg": 991,
	"./icons/plus.svg": 49,
	"./icons/prenota.svg": 195,
	"./icons/promo.svg": 45,
	"./icons/promo2.svg": 992,
	"./icons/promo3.svg": 993,
	"./icons/promo_10.svg": 994,
	"./icons/promo_classic.svg": 995,
	"./icons/remove_prod.svg": 271,
	"./icons/remove_prodOLD.svg": 996,
	"./icons/shop_list.svg": 272,
	"./icons/specs.svg": 44,
	"./icons/whatsapp.svg": 38,
	"./icons/world.svg": 40,
	"./logo.svg": 997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 969;